import { EntityRepository, Repository } from "typeorm";
import { GrnReturns } from "../grn-return-entity";

@EntityRepository(GrnReturns)
export class GrnReturnRepository extends Repository<GrnReturns>{

    
}